module.exports = __webpack_public_path__ + "img/quote.14047252.png";